import { ScopesOfWork } from "../scopeOfWork";
import { TestEvents } from "../testEvents";

export function IncompleteView() {
  return (
    <ul>
      <li className="mb-3">
        <ScopesOfWork filters={{ incomplete: true }} />
      </li>
      <li className="mb-3">
        <TestEvents filters={{ incomplete: true }} />
      </li>
    </ul>
  );
}
